/**
 * Find all non-overlapping match ranges of `query` in `text`.
 * Escapes special regex characters in query for literal search.
 */
export function findMatchRanges(
	text: string,
	query: string,
	caseSensitive: boolean
): Array<{ start: number; end: number }> {
	if (!query.trim()) return []
	const escaped = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
	const flags = caseSensitive ? 'g' : 'gi'
	const regex = new RegExp(escaped, flags)
	const ranges: Array<{ start: number; end: number }> = []
	let match = regex.exec(text)
	while (match !== null) {
		ranges.push({ start: match.index, end: match.index + match[0].length })
		match = regex.exec(text)
	}
	return ranges
}

/**
 * Replace the match at `matchIndex` in `text` with `replaceWith`.
 * Uses the same matching logic as findMatchRanges.
 */
export function replaceMatchAt(
	text: string,
	query: string,
	replaceWith: string,
	caseSensitive: boolean,
	matchIndex: number
): string {
	const ranges = findMatchRanges(text, query, caseSensitive)
	const r = ranges[matchIndex]
	if (!r) return text
	return text.slice(0, r.start) + replaceWith + text.slice(r.end)
}

/**
 * Replace all matches of `query` in `text` with `replaceWith`.
 */
export function replaceAllMatches(
	text: string,
	query: string,
	replaceWith: string,
	caseSensitive: boolean
): string {
	if (!query.trim()) return text
	const escaped = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
	const flags = caseSensitive ? 'g' : 'gi'
	return text.replace(new RegExp(escaped, flags), replaceWith)
}
